import { useSeriesCardContext } from './series-card'
import { HighIntensitySvgIcon, LowIntensitySvgIcon, MediumIntensitySvgIcon } from '../../util/images'
import React from 'react'
import { Skeleton } from 'src/component/ui/skeleton'
import { useProgrammeIntensities } from 'src/hook/use-programmes'
import { cn } from 'src/lib/utils'

interface SeriesCardIntensityBadgeProps {
  className?: string
}

const intensityMap: Record<string, { label: string; backgroundColorClassName: string; IconComponent: React.ReactNode }> = {
  low: {
    label: 'Low Intensity',
    backgroundColorClassName: 'bg-success',
    IconComponent: <LowIntensitySvgIcon />,
  },
  medium: {
    label: 'Medium Intensity',
    backgroundColorClassName: 'bg-primary',
    IconComponent: <MediumIntensitySvgIcon />,
  },
  high: {
    label: 'High Intensity',
    backgroundColorClassName: 'bg-error',
    IconComponent: <HighIntensitySvgIcon />,
  },
}

export const SeriesCardIntensityBadge = ({ className }: SeriesCardIntensityBadgeProps): React.ReactElement | null => {
  const { series } = useSeriesCardContext()
  const { data: intensities = [], isLoading } = useProgrammeIntensities()

  series.intensityId
  const intensity = intensities.find((item) => item.id === series.intensityId)

  if (isLoading && !intensities.length) {
    return (
      <div className={cn('flex flex-row justify-end', className)}>
        <Skeleton className="h-7 w-24 rounded-full bg-primary-gray" />
      </div>
    )
  }

  if (!intensity) return null

  const intensityData = intensityMap[intensity.name]

  if (!intensityData) return null

  return (
    <div className={cn('flex justify-end', className)}>
      <div className={cn('flex items-center gap-2 rounded-full px-2 py-1', intensityData.backgroundColorClassName)}>
        {intensityData.IconComponent}
        <p className="text-xs font-medium font-roboto-condensed capitalize text-ivory">{intensityData.label}</p>
      </div>
    </div>
  )
}
